var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleFillShareMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#A020FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0777 16.4998C11.0777 18.1991 9.70009 19.5767 8.00075 19.5767C6.30141 19.5767 4.92383 18.1991 4.92383 16.4998C4.92383 14.8004 6.30141 13.4229 8.00075 13.4229C9.70009 13.4229 11.0777 14.8004 11.0777 16.4998Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.23 9.73047L11.0762 14.0382",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.23 23.2695L11.0762 18.9618",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3843 24.4998C23.3843 26.1991 22.0067 27.5767 20.3074 27.5767C18.6081 27.5767 17.2305 26.1991 17.2305 24.4998C17.2305 22.8004 18.6081 21.4229 20.3074 21.4229C22.0067 21.4229 23.3843 22.8004 23.3843 24.4998Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3843 8.49977C23.3843 10.1991 22.0067 11.5767 20.3074 11.5767C18.6081 11.5767 17.2305 10.1991 17.2305 8.49977C17.2305 6.80044 18.6081 5.42285 20.3074 5.42285C22.0067 5.42285 23.3843 6.80044 23.3843 8.49977Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleFillShareMedia);
export default __webpack_public_path__ + "static/media/PurpleFillShareMedia.78a9f2ba6f1db431e6a0783b8b54967c.svg";
export { ForwardRef as ReactComponent };